import Vue from "vue";
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.css";
import router from "./router";
import App from "./App";
import Page from "@/components/Page";
import { auth, db } from "@/helpers/firebase";

Vue.use(VueMaterial);
Vue.material.registerTheme("default", {
  primary: {
    color: "green",
    hue: 600
  },
  accent: "blue",
  warn: "red",
  background: "white"
});

Vue.config.productionTip = false;

// register global component
Vue.component("appPage", Page);

const LAST_LIST = "lastList";
const INVITE_TOKEN = "inviteToken";
router.afterEach(to => {
  if (to.name === "list") {
    localStorage.setItem(LAST_LIST, to.params.id);
  }
  if (to.name === "login" && to.params.inviteCode) {
    localStorage.setItem(INVITE_TOKEN, to.params.inviteCode);
  }
});

/* eslint-disable no-new */
new Vue({
  data: {
    currentUser: null,
    userData: null
  },
  router,
  render: h => h(App),
  // Our earliest lifecycle hook
  beforeCreate: function() {
    auth.onAuthStateChanged(user => {
      // add user to $root.currentUser
      this.currentUser = user;
      // redirect if not logged in
      if (user) {
        this.$rtdbBind("userData", db.child("users").child(user.uid));
        const lastList = localStorage.getItem(LAST_LIST);
        if (lastList) {
          if (lastList != this.$route.params.id) {
            this.$router.push({ name: "list", params: { id: lastList } });
          }
        } else {
          this.$router.push({ name: "home" });
        }
        const inviteCode = localStorage.getItem(INVITE_TOKEN);
        if (inviteCode) {
          const [listUid, token] = inviteCode.split(":");
          const body = {
            userUid: user.uid,
            listUid,
            token
          };
          fetch(
            "https://us-central1-firebase-ptw.cloudfunctions.net/acceptInvite",
            {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
              },
              method: "POST",
              body: JSON.stringify(body)
            }
          ).then(res => {
            console.log(res);
            if (res.status === 200) {
              this.$router.push({ name: "list", params: { id: listUid } });
              localStorage.removeItem(INVITE_TOKEN);
            }
          });
        }
      } else {
        this.$router.push({ name: "login" });
        this.userData = null;
      }
    });
  }
}).$mount("#app");
